import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
//@ts-ignore missing typedefs
import VirtualList from "vue-virtual-scroll-list";
import MultipleViewItem from "./MultipleViewItem.vue";
import { useHistoryStore } from "@/stores/historyStore";
import SelectorModal from "@/components/History/Modals/SelectorModal.vue";
import { useAnimationFrameScroll } from "@/composables/sensors/animationFrameScroll";
import { useAnimationFrameResizeObserver } from "@/composables/sensors/animationFrameResizeObserver";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultipleViewList',
    props: {
        histories: null,
        currentHistory: null,
        handlers: null,
        filter: { default: "" }
    },
    setup(__props) {
        const props = __props;
        const historyStore = useHistoryStore();
        const scrollContainer = ref(null);
        const { arrived } = useAnimationFrameScroll(scrollContainer);
        const isScrollable = ref(false);
        useAnimationFrameResizeObserver(scrollContainer, ({ clientSize, scrollSize }) => {
            isScrollable.value = scrollSize.width >= clientSize.width + 1;
        });
        const scrolledLeft = computed(() => !isScrollable.value || arrived.left);
        const scrolledRight = computed(() => !isScrollable.value || arrived.right);
        const selectedHistories = computed(() => historyStore.pinnedHistories);
        function removeHistoryFromList(history) {
            historyStore.unpinHistory(history.id);
        }
        if (!selectedHistories.value.length) {
            historyStore.pinHistory(props.histories[0].id);
        }
        function addHistoriesToList(histories) {
            histories.forEach((history) => {
                const historyExists = selectedHistories.value.find((h) => h.id === history.id);
                if (!historyExists) {
                    historyStore.pinHistory(history.id);
                }
            });
        }
        return { __sfc: true, historyStore, props, scrollContainer, arrived, isScrollable, scrolledLeft, scrolledRight, selectedHistories, removeHistoryFromList, addHistoriesToList, VirtualList, MultipleViewItem, SelectorModal };
    }
});
